import React from 'react'

const ContentBasic = ({ employee }) => {
    return (
        <div className='flex px-5'>
            <div className='w-1/3'>
                <h2 className='font-bold text-xl'>Personal data</h2>
                <p className='text-sm'>Your Email Address is your identity on System is used to Log In.</p>
            </div>
            <div className='w-full p-3'>
                {employee?.map((data) => (<div className='flex justify-between'>
                    <p className='p-1 text-xs font-bold'>{data?.label}</p>
                    <p className='p-1 text-xs text-end'>{data?.value}</p>
                </div>))}
            </div>
        </div>
    )
}

export default ContentBasic;
